<template>
  <div
    class="m-content-editor-primary"
    spellcheck="false"
  >
    <div class="m-content-editor-primary-menu">
      <form name="html-edition">
        <button
          v-for="(button, index) in menuButtons"
          v-show="(button.name === 'Video' && currentTask.videos) ||
            button.name !== 'Video'"
          :key="`btn-editor-${index}`"
          :class="['a-tooltip-primary a-tooltip-bottom menu-button-action', button.class]"
          :data-tooltip-text="button.name"
          :disabled="buttonPrimary.sending"
          @click.prevent="insertBlock(button.blockType)"
        >
          <i :class="button.icon"></i>
        </button>

        <button
          v-show="currentTask.archivos"
          class="a-tooltip-primary a-tooltip-bottom menu-button-action menu-button-action-image"
          data-tooltip-text="Imagen"
          :disabled="buttonPrimary.sending"
          @click.prevent="insertImage"
        >
          <i class="far fa-file-image"></i>
        </button>

        <input
          id="files"
          class="inputFileHidden"
          name="files"
          ref="files"
          type="file"
          @change.prevent="handleFile"
        />

        <button
          v-show="currentTask.archivos"
          class="a-tooltip-primary a-tooltip-bottom menu-button-action menu-button-action-document"
          data-tooltip-text="Documento"
          :disabled="buttonPrimary.sending"
          @click.prevent="insertFile"
        >
          <i class="far fa-file-alt"></i>
        </button>

        <input
          id="images"
          class="inputImageHidden"
          name="images"
          ref="images"
          type="file"
          @change.prevent="handleImage"
        />
      </form>
    </div>

    <draggable
      :animation="0"
      :list="currentHtml.blocks"
      :class="['m-content-editor-primary-html', { 'm-content-editor-primary-html-disabled': buttonPrimary.sending }]"
      :disabled="buttonPrimary.sending"
      draggable=".sortable-item"
      fallback-class="display-none"
      :force-fallback="true"
      group="sortable-item"
      :pull="false"
      :scroll="true"
      :scroll-sensitivity="200"
      tag="div"
    >
      <Block
        v-for="(block, index) in currentHtml.blocks"
        :key="block.id"
        :is="`MoleculeContentEditorBlock${block.type}`"
        :can-edit="!buttonPrimary.sending"
        :block="block"
        :index="index"
        :time="currentHtml.time"
        @deleteBlock="deleteBlock"
        @insertAudio="insertAudio"
        @insertLink="insertLink"
        @insertVideo="insertVideo"
        @updateText="updateText"
      />
    </draggable>

    <form
      autocomplete="off"
      class="menu-button-action-save"
      name="editor-form"
      @submit.prevent="setNodoActivoTarea"
    >
      <AtomButtonSecondary
        :button-secondary="buttonSecondary.cancelChanges"
        :disabled="buttonPrimary.sending"
        :element="datos"
        @resetEditor="resetEditor"
      />
      <AtomButtonPrimary
        :button-primary="buttonPrimary"
        :disabled="buttonPrimary.sending"
      />
    </form>
    <div id="toScroll"></div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'MoleculeContentEditor',

  components: {
    draggable,
    MoleculeContentEditorBlockAudio: () => import('@/components/molecules/MoleculeContentEditorBlockAudio'),
    MoleculeContentEditorBlockDocument: () => import('@/components/molecules/MoleculeContentEditorBlockDocument'),
    MoleculeContentEditorBlockIframeVideo: () => import('@/components/molecules/MoleculeContentEditorBlockIframeVideo'),
    MoleculeContentEditorBlockImage: () => import('@/components/molecules/MoleculeContentEditorBlockImage'),
    MoleculeContentEditorBlockInputAudio: () => import('@/components/molecules/MoleculeContentEditorBlockInputAudio'),
    MoleculeContentEditorBlockInputLink: () => import('@/components/molecules/MoleculeContentEditorBlockInputLink'),
    MoleculeContentEditorBlockInputVideo: () => import('@/components/molecules/MoleculeContentEditorBlockInputVideo'),
    MoleculeContentEditorBlockLink: () => import('@/components/molecules/MoleculeContentEditorBlockLink'),
    MoleculeContentEditorBlockParagraph: () => import('@/components/molecules/MoleculeContentEditorBlockParagraph'),
    MoleculeContentEditorBlockTitle1: () => import('@/components/molecules/MoleculeContentEditorBlockTitle1')
  },

  props: {
    element: {
      type: Object,
      default: () => ({ tipo: 0 })
    },

    nodos: {
      type: Array,
      default: () => ([])
    }
  },

  data () {
    return {
      blocks: [
        {
          type: 'Audio',
          data:
            {
              url: ''
            }
        },

        {
          type: 'Document',
          data:
            {
              file: '',
              name: ''
            }
        },

        {
          type: 'Image',
          data:
            {
              file: '',
              name: ''
            }
        },

        {
          type: 'IframeVideo',
          data:
            {
              embed: '',
              url: ''
            }
        },

        {
          type: 'InputAudio',
          data:
            {
              url: ''
            }
        },

        {
          type: 'InputLink',
          data:
            {
              url: ''
            }
        },

        {
          type: 'InputVideo',
          data:
            {
              url: ''
            }
        },

        {
          type: 'Link',
          data:
            {
              url: ''
            }
        },

        {
          type: 'Paragraph',
          data:
            {
              text: ''
            }
        },

        {
          type: 'Title1',
          data:
            {
              text: ''
            }
        },

        {
          type: 'Title2',
          data:
            {
              text: ''
            }
        },

        {
          type: 'Title3',
          data:
            {
              text: ''
            }
        },

        {
          type: 'Title4',
          data:
            {
              text: ''
            }
        },

        {
          type: 'Title5',
          data:
            {
              text: ''
            }
        },

        {
          type: 'Title6',
          data:
            {
              text: ''
            }
        }
      ],

      buttonPrimary: {
        action: 'Guardar',
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        cancelChanges: {
          class: 'a-button-secondary a-button-reset-secondary display-flex-row-center margin-right-small',
          component: '',
          icon: 'far fa-times',
          method: 'resetEditor',
          text: 'Cancelar',
          type: 'button'
        }
      },

      currentHtml: {
        time: 0,

        blocks: []
      },

      currentTask: {
        archivos: false,
        cumplido: 0,
        diaEntrega: 0,
        noCumplido: 0,
        videos: false
      },

      datos: {
        academia: 0,
        nodo: '',
        texto: ''
      },

      defaultHtml: {
        time: 0,
        blocks: []
      },

      defaultTask: {
        archivos: false,
        cumplido: 0,
        diaEntrega: 0,
        noCumplido: 0,
        videos: false
      },

      isFileExtensionValid: true,
      isFileSizeValid: true,

      menuButtons: [
        {
          blockType: 'Title1',
          class: 'menu-button-action-title',
          icon: 'far fa-heading',
          name: 'Título'
        },

        {
          blockType: 'Paragraph',
          class: 'menu-button-action-paragraph',
          icon: 'far fa-paragraph',
          name: 'Párrafo'
        },

        {
          blockType: 'InputVideo',
          class: 'menu-button-action-video',
          icon: 'far fa-play',
          name: 'Video'
        },

        {
          blockType: 'InputAudio',
          class: 'menu-button-action-audio',
          icon: 'far fa-volume-up',
          name: 'Audio'
        },

        {
          blockType: 'InputLink',
          class: 'menu-button-action-link',
          icon: 'far fa-link',
          name: 'Enlace'
        }
      ]
    }
  },

  created () {
    this.datos.academia = this.$store.getters.getAcademyData.id
    this.setCurrentHtml()
  },

  methods: {
    deleteBlock (index) {
      // TODO: preguntar si está seguro de eliminar el bloque
      this.currentHtml.blocks.splice(index, 1)
    },

    handleImage (event) {
      let input = event.target
      this.isFileExtensionValid = this.$files.allowedFileExtension(input.files[0].name, 'image')
      this.isFileSizeValid = this.$files.allowedFileSize(input.files[0].size)
      if (input.files && input.files[0] && this.isFileExtensionValid && this.isFileSizeValid) {
        let newImage = JSON.parse(JSON.stringify(this.blocks.find(block => block.type === 'Image')))
        var reader = new FileReader()
        reader.onload = (e) => {
          newImage.data.file = e.target.result
          newImage.data.name = input.files[0].name
        }
        reader.readAsDataURL(input.files[0])
        this.currentHtml.blocks.push(newImage)
        window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight)
      } else if (!this.isFileExtensionValid) {
        this.$modal.showModal('MoleculeContentEditorModalImageExtensionError')
      } else if (!this.isFileSizeValid) {
        this.$modal.showModal('MoleculeContentEditorModalFileSizeError')
      }
    },

    handleFile (event) {
      let input = event.target
      this.isFileExtensionValid = this.$files.allowedFileExtension(input.files[0].name, 'document')
      this.isFileSizeValid = this.$files.allowedFileSize(input.files[0].size)
      if (input.files && input.files[0] && this.isFileExtensionValid && this.isFileSizeValid) {
        let newDocument = JSON.parse(JSON.stringify(this.blocks.find(block => block.type === 'Document')))
        var reader = new FileReader()
        reader.onload = (e) => {
          newDocument.data.file = e.target.result
          newDocument.data.name = input.files[0].name
        }
        reader.readAsDataURL(input.files[0])
        this.currentHtml.blocks.push(newDocument)
        window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight)
      } else if (!this.isFileExtensionValid) {
        this.$modal.showModal('MoleculeContentEditorModalFileExtensionError')
      } else if (!this.isFileSizeValid) {
        this.$modal.showModal('MoleculeContentEditorModalFileSizeError')
      }
    },

    insertBlock (type) {
      let newBlock = this.blocks.find(block => block.type === type)
      newBlock.id = `block-${Math.floor(Math.random() * 1000)}`
      this.currentHtml.blocks.push(JSON.parse(JSON.stringify(newBlock)))
      document.getElementById('toScroll').scrollIntoView({ block: 'center', behavior: 'smooth' })
    },

    insertImage () {
      document.getElementById('images').click()
    },

    insertFile () {
      document.getElementById('files').click()
    },

    insertAudio (urlAudio, index) {
      let newAudio = JSON.parse(JSON.stringify(this.blocks.find(block => block.type === 'Audio')))
      newAudio.data.url = urlAudio
      this.currentHtml.blocks.splice(index, 1, newAudio)
    },

    insertLink (urlLink, index) {
      let newLink = JSON.parse(JSON.stringify(this.blocks.find(block => block.type === 'Link')))
      newLink.data.url = urlLink
      this.currentHtml.blocks.splice(index, 1, newLink)
    },

    insertVideo (embedVideo, urlVideo, index) {
      let newIframeVideo = JSON.parse(JSON.stringify(this.blocks.find(block => block.type === 'IframeVideo')))
      // guardo url original
      newIframeVideo.data.url = urlVideo
      // convierto url a embed -> https://www.youtube.com/embed/-wqqctEYyJM
      newIframeVideo.data.embed = embedVideo
      this.currentHtml.blocks.splice(index, 1, newIframeVideo)
    },

    resetEditor () {
      this.setCurrentHtml()
    },

    setCurrentHtml () {
      // this.currentHtml = this.$store.getters.getAssetSelectedNode.texto
      //   ? Object.assign({}, JSON.parse(this.$store.getters.getAssetSelectedNode.texto))
      //   : Object.assign({}, this.defaultHtml)

      this.currentHtml = Object.assign({}, this.defaultHtml)
      this.currentHtml.blocks = [...this.currentHtml.blocks]

      // this.currentHtml.blocks.forEach((block, i) => {
      //   this.currentHtml.blocks[i] = Object.assign({}, block)
      //   this.currentHtml.blocks[i].data = Object.assign({}, block.data)
      //   this.currentHtml.blocks[i].id = `block-${new Date().getTime() + i}`
      // })

      let selectedNode = Object.assign({}, this.$store.getters.getSelectedMapNode)
      this.currentTask = selectedNode.tarea
        ? Object.assign({}, selectedNode.tarea)
        : this.defaultTask
      this.datos.nodo = selectedNode.id
    },

    setNodoActivoTarea () {
      this.currentHtml.blocks = this.currentHtml.blocks.filter(block =>
        block.type !== 'InputAudio' &&
        block.type !== 'InputLink' &&
        block.type !== 'InputVideo')
      this.currentHtml.time = Date.now()
      this.datos.texto = JSON.stringify(this.currentHtml)

      if (!this.buttonPrimary.sending && this.currentHtml.blocks.length > 0) {
        this.buttonPrimary.sending = true
        this.$services.create('inscripcion', 'createInscripcionNodoActivoTarea', this.datos,
          [this.$store.getters.getSelectedMap.id_inscripcion])
          .then(response => {
            this.$emit('readInscripcionNodoActivoTareas')
            this.$alerts.pushAlert('mContentEditor', 'setNodoActivoTarea', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mContentEditor', 'setNodoActivoTarea', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    },

    updateText (index, newText) {
      this.currentHtml.blocks[index].data.text = newText
    }
  }
}
</script>
